"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var tagObject = {
  label: _propTypes.string.isRequired,
  backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
  textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS)
};
var optionsObject = {
  label: _propTypes.string.isRequired,
  subLabel: _propTypes.string,
  value: _propTypes.any.isRequired,
  tag: (0, _propTypes.shape)(tagObject)
};
var _default = {
  PropTypes: {
    data: (0, _propTypes.shape)({
      label: _propTypes.string.isRequired,
      options: (0, _propTypes.arrayOf)(optionsObject)
    }).isRequired,
    value: _propTypes.any,
    onExpand: _propTypes.func,
    expand: _propTypes.bool,
    footerMessage: _propTypes.string,
    component: _propTypes.element,
    onChange: _propTypes.func,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    isAccordion: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;